import { Action, createReducer, createSelector, on } from '@ngrx/store';
import { IOpenedPrintOptionsAccordions } from '../interfaces/opened-print-options-accordions.interface';
import * as fromActions from './app.state.actions';

export const appStateFeatureKey = 'modesoAppState';

export interface FeatureState {
    user: string;
    uploadedFileChanged: boolean;
    supportOperation: boolean;
    openedPrintOptionsAccordions: IOpenedPrintOptionsAccordions;
}

export interface AppState {
    modesoAppState: FeatureState;
}

export const selectFeature = (state: AppState) => state.modesoAppState;

export const selectUser = createSelector(selectFeature, (state: FeatureState) => state.user);

export const selectuploadedFileChanged = createSelector(
    selectFeature,
    (state: FeatureState) => state.uploadedFileChanged,
);

export const selectSupportOperation = createSelector(selectFeature, (state: FeatureState) => state.supportOperation);

export const selectOpenedPrintOptionsAccordions = createSelector(
    selectFeature,
    (state: FeatureState) => state.openedPrintOptionsAccordions,
);

export const initialState: FeatureState = {
    user: '',
    uploadedFileChanged: false,
    supportOperation: false,
    openedPrintOptionsAccordions: {
        consistencyChecksAccordion: false,
        componentsAccordion: false,
        settingsAccordion: false,
        signatureAccordion: false,
        colorsAccordion: false,
        // FX (REV-21512): MUST be false, never absent — an undefined [isOpened] desyncs the
        // accordion item's expanded state at birth and the opened/closed feedback loop oscillates.
        fxAccordion: false,
    },
};

const appStateReducer = createReducer(
    initialState,
    on(fromActions.onSetUser, (state, action) => {
        return { ...state, user: action.payload };
    }),
    on(fromActions.onSetUploadedFileChanged, (state, action) => {
        return { ...state, uploadedFileChanged: action.payload };
    }),
    on(fromActions.onSetSupportOperation, (state, action) => {
        return { ...state, supportOperation: action.payload };
    }),
    on(fromActions.onSetOpenedPrintOptionsAccordions, (state, action) => {
        return { ...state, openedPrintOptionsAccordions: action.payload };
    }),
    on(fromActions.flushState, () => ({ ...initialState })),
);

export function reducer(state: FeatureState | undefined, action: Action) {
    return appStateReducer(state, action);
}
